"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.append = void 0;

var _curry = require("../curry/curry");

var _append = function _append(subset, source) {
  if (Array.isArray(source)) {
    return source.concat(subset);
  }

  return source + subset;
};
/**
 * Add array or element at the end of array
 *
 * @param {mixed|Array} subset Content to add
 * @param {Array}       source Source array to append to
 *
 * @returns {Array}
 *
 * @name append
 * @tag Array
 * @signature (subset: String, source: String) => String
 * @signature (subset: mixed|Array, source: Array) => Array
 *
 * @see {@link prepend}
 *
 * @example
 * append([1])([4, 5])
 * // => [1, 4, 5]
 */


var append = (0, _curry.curry)(_append);
exports.append = append;